import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Wrench } from "lucide-react";

interface ConsertoDados {
  ehConserto?: boolean;
  materialCliente?: boolean;
  tipoDefeito?: string;
  descricaoDefeito?: string;
  areiaAfetada?: string;
  nivelDificuldade?: string;
  dataEntrada?: string;
  observacoes?: string;
}

interface ConsertoPedidoCardProps {
  consertoDados?: ConsertoDados;
  tipoPedido: string;
}

export function ConsertoPedidoCard({ consertoDados, tipoPedido }: ConsertoPedidoCardProps) {
  if (!consertoDados || (tipoPedido !== "conserto" && tipoPedido !== "ajuste")) {
    return null;
  }

  return (
    <Card className="border-l-4 border-l-purple-500">
      <CardHeader className="pb-3">
        <CardTitle className="text-sm flex items-center gap-2">
          <Wrench className="w-4 h-4" />
          🔧 Detalhes do {tipoPedido === "conserto" ? "Conserto" : "Ajuste"}
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        <div className="grid grid-cols-2 gap-3 text-sm">
          {consertoDados.tipoDefeito && (
            <div>
              <p className="text-xs text-gray-500">Tipo de Defeito</p>
              <p className="font-medium">{consertoDados.tipoDefeito}</p>
            </div>
          )}
          {consertoDados.nivelDificuldade && (
            <div>
              <p className="text-xs text-gray-500">Dificuldade</p>
              <p className="font-medium capitalize">{consertoDados.nivelDificuldade}</p>
            </div>
          )}
          {consertoDados.areiaAfetada && (
            <div>
              <p className="text-xs text-gray-500">Área Afetada</p>
              <p className="font-medium">{consertoDados.areiaAfetada}</p>
            </div>
          )}
          {consertoDados.dataEntrada && (
            <div>
              <p className="text-xs text-gray-500">Data Entrada</p>
              <p className="font-medium">{consertoDados.dataEntrada}</p>
            </div>
          )}
        </div>

        {consertoDados.descricaoDefeito && (
          <div>
            <p className="text-xs text-gray-500">Descrição</p>
            <p className="text-sm">{consertoDados.descricaoDefeito}</p>
          </div>
        )}

        {consertoDados.observacoes && (
          <div>
            <p className="text-xs text-gray-500">Observações</p>
            <p className="text-sm">{consertoDados.observacoes}</p>
          </div>
        )}

        {consertoDados.materialCliente && (
          <div className="text-xs text-blue-700 bg-blue-50 p-2 rounded">
            ✓ Material trazido pelo cliente
          </div>
        )}
      </CardContent>
    </Card>
  );
}
